import { useState, useEffect } from 'react';
import {
  EMPTY_STRING,
  RESEND_DISABLED_TIMEOUT,
} from '@assetron/common/constants/constant';
import useTimeouts from '@assetron/common/hooks/useTimeouts';

const usePasswordState = () => {
  const [password, setPassword] = useState(EMPTY_STRING);
  const [isApiError, setIsApiError] = useState(false);
  const { timer } = useTimeouts();

  useEffect(() => {
    if (isApiError) {
      timer(() => setIsApiError(false), RESEND_DISABLED_TIMEOUT);
    }
  }, [isApiError, timer]);

  return {
    password,
    setPassword,
    isApiError,
    setIsApiError,
  };
};

export default usePasswordState;
